import { SAVE_CART_LOAD, SAVE_CART_UPDATE, SAVE_CART_LOAD_ERROR } from '../constants';
const DEFAULT_STATE = {
    listItem: []
};
export const saveCartView = (state = DEFAULT_STATE, action) => {
    const { type, payload } = action;
    switch (type) {     
        case SAVE_CART_LOAD:
            return {     
                listItem: payload,           
            };
        default:
            return state;
    }
};